<template>
  <Row id="Employee">
    <Col :span="24" class="title">
      <TypographyTitle>{{$t('nav.name.EmployeeManage')}}</TypographyTitle>
    </Col>
    <Col :span="24" class="content">
      <Row :gutter="[16,32]">
        <Col :span="24" >
          <Form :model="searchForm">
            <Row :gutter="30">
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('employee.name.search')" name="search">
                  <Input :placeholder="$t('employee.name.search')" v-model:value="searchForm.search"></Input>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('employee.name.status')">
                  <Select v-model:value="searchForm.status" :placeholder="$t('public.placeholder.please_select')">
                    <SelectOption :value="null">{{ $t('employee.name.status_all') }}</SelectOption>
                    <SelectOption :value="0">{{ $t('employee.name.status_be_on_the_job') }}</SelectOption>
                    <SelectOption :value="1">{{ $t('employee.name.status_quit') }}</SelectOption>
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('attendance.name.department')" name="department">
                      <!--关联表的下拉选择-->
                      <Select
                              v-model:value="searchForm.idDep"
                      >
                      <SelectOption :value="null">{{ $t('attendance.name.select_all') }}</SelectOption>
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['departmentList']" :value="item['idDep']">{{ item['name'] }}</SelectOption>
                      </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('role.field.name')" name="role">
                      <!--关联表的下拉选择-->
                      <Select
                              v-model:value="searchForm.idRol"
                      >
                      <SelectOption :value="null">{{ $t('attendance.name.select_all') }}</SelectOption>
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['roleList']" :value="item['idRol']">{{ item['name'] }}</SelectOption>
                      </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('annualLeavePlan.field.plan_name')" name="annualLeavePlan">
                      <!--关联表的下拉选择-->
                      <Select
                              v-model:value="searchForm.idAnnLeaPla"
                      >
                      <SelectOption :value="null">{{ $t('attendance.name.select_all') }}</SelectOption>
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['annualLeavePlanList']" :value="item['idAnnLeaPla']">{{ item['planName'] }}</SelectOption>
                      </Select>
                </FormItem>
              </Col>
              <Col span="8">
                    <FormItem :label="$t('employee.field.duty_plan_type')" name="dutyPlanType">
                      <Select
                              v-model:value="searchForm.dutyPlanType"
                              :dropdownStyle="{ zIndex: 9999999950 }"
                      >
                      <SelectOption :value="null">{{ $t('attendance.name.select_all') }}</SelectOption>
                      <SelectOption :key="sk" v-for="(item,sk) in selectList['dutyPlanTypeList']" :value="item['value']">{{ item['label'] }}</SelectOption>
                      </Select>
                  </FormItem>
                </Col>
              <Col :xs="24" :sm="8" class="text-right">
                <Button type="primary" @click="search_submit">{{$t('public.name.search')}}</Button>&nbsp;
                <Button @click="search_reset">{{$t('public.name.reset')}}</Button>&nbsp;
                <Button type="primary" @click="exportXml">{{$t('public.name.export')}}</Button>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col :span="24">
        <Table :columns="columns" :dataSource="list" :scroll="{ x: true }" rowKey="idEmp" :loading="loading" :pagination="tablePagination" @change="chang_page">
            <template #actionTitle>
              <span>
                {{$t("public.table.action")}}
                <Button v-if="checkPermission('EmployeeManage.Add')" type="primary" size="small" shape="circle" @click="add()">
                  <PlusOutlined />
                </Button>
              </span>
            </template>
            <template #action="{text,record}">
              <div>
                <!-- <div class="pc-display">
                  <Button type="default" size="small" @click="detail(text)">{{$t("public.name.detail")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('EmployeeManage.Edit')" type="primary" size="small" @click="edit(text)">{{$t("public.name.edit")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('EmployeeManage.Delete')" type="primary" danger size="small" @click="del(text.idEmp)">{{$t("public.name.del")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('EmployeeManage.Quit') && text.status === 0" type="primary" danger size="small" @click="quit(text.idEmp)">{{$t("employee.name.quit")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('EmployeeManage.Reinstated') && text.status === 1" type="primary" danger size="small" @click="reinstated(text.idEmp)">{{$t("employee.name.reinstated")}}</Button>
                </div> -->
                <Dropdown :trigger="['click']">
                  <template #overlay>
                    <Menu>
                      <MenuItem @click="detail(text)">{{$t('public.name.detail')}}</MenuItem>
                      <MenuItem v-if="checkPermission('EmployeeManage.Edit')" @click="edit(text)">{{$t('public.name.edit')}}</MenuItem>
                      <MenuItem v-if="checkPermission('EmployeeManage.Quit') && text.status === 0 && record.idEmp !== 1" danger @click="quit(text.idEmp)">{{$t('employee.name.quit')}}</MenuItem>
                      <MenuItem v-if="checkPermission('EmployeeManage.RevokeQuit') && text.status === 1 && record.idEmp !== 1" danger @click="revokeQuit(text.idEmp)">{{$t('employee.name.revokeQuit')}}</MenuItem>
                      <MenuItem v-if="checkPermission('EmployeeManage.Reinstated') && text.status === 1 && record.idEmp !== 1" danger @click="reinstated(text.idEmp)">{{$t('employee.name.reinstated')}}</MenuItem>
                      <MenuItem v-if="checkPermission('EmployeeManage.GccsSetUser')" danger @click="gccsSetUser(text)">{{$t('employee.name.gccsSetUser')}}</MenuItem>
                      <MenuItem v-if="record.idEmp !== 1" danger @click="resetPassword(text)">{{$t('employee.name.reset_password')}}</MenuItem>
                    </Menu>
                  </template>
                  <Button size="small">
                    {{$t("public.name.more")}}
                    <DownOutlined />
                  </Button>
                </Dropdown>
              </div>
            </template>
          </Table>
        </Col>
      </Row>
    </Col>
    <NewEmployeeDetail ref="refEmployeeDetail"></NewEmployeeDetail>
    <EmployeeEdit ref="refEmployeeEdit" @updateList="get_list"></EmployeeEdit>
    <NewEmployeeEntryRecordEdit ref="refNewEmployeeEntryRecordEdit" @updateList="get_list"></NewEmployeeEntryRecordEdit>
    <GccsSetUser ref="refGccsSetUser" @updateList="get_list"></GccsSetUser>
    <ResetPassword ref="refResetPassword" @updateList="get_list"></ResetPassword>
  </Row>
</template>

<script>
import { createVNode } from "vue";
import { Row, Col, Table, Typography, Tag, Button, Dropdown, Menu, Modal, Form, Input, Select, message } from "ant-design-vue";
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { EmployeeList } from "@/api/EmployeeList";
import { EmployeeDelete } from "@/api/EmployeeDelete"
import { DepartmentListAll } from "@/api/DepartmentListAll";
import { RoleListAll } from "@/api/RoleListAll";
import { AnnualLeavePlanListAll } from "@/api/AnnualLeavePlanListAll"
import { EmployeeExport } from "@/api/EmployeeExport"
import { EmployeeRevokeQuit } from "@/api/EmployeeRevokeQuit"
import NewEmployeeDetail from "@/components/Home/NewEmployeeDetail";
import EmployeeEdit from "@/components/Home/EmployeeEdit";
import NewEmployeeEntryRecordEdit from "@/components/Home/NewEmployeeEntryRecordEdit";
import ResetPassword from "@/components/Home/ResetPassword";
import GccsSetUser from "@/components/Home/GccsSetUser";
import moment from "moment";

export default {
  name: "EmployeeManage",
  components: {
    Row,
    Col,
    Table,
    Form,
    FormItem: Form.Item,
    TypographyTitle: Typography.Title,
    Tag,
    Button,
    Input,
    Select,
    SelectOption: Select.Option,
    Dropdown,
    DownOutlined,
    PlusOutlined,
    ExclamationCircleOutlined,
    Menu,
    MenuItem: Menu.Item,
    NewEmployeeDetail,
    EmployeeEdit,
    NewEmployeeEntryRecordEdit,
    GccsSetUser,
    ResetPassword,
  },
  data() {
    return {
      searchForm: {
        status: 0,
        idDep: null,
        idRol:null,
        idAnnLeaPla:null,
        dutyPlanType:null,
      },
      tablePagination: {
        pageSizeOptions: ["10", "20", "50", "100"],
        showSizeChanger: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
      list: [],
      columns: [
          { title: this.$t("employee.table.id_emp"), fixed: "left", dataIndex: "idEmp", key: "idEmp" },
          { title: this.$t("employee.table.nick_name"), dataIndex: "nickName", key: "nickName" },
          { title: this.$t("employee.table.account"),  dataIndex: "account", key: "account" },
          { title: this.$t("employee.table.name_tw"),  dataIndex: "nameTw", key: "nameTw" },
          { title: this.$t("employee.table.name_en"),  dataIndex: "nameEn", key: "nameEn" },
          { title: this.$t("employee.table.id_rol"),  dataIndex: "roleName", key: "roleName" },
          { title: this.$t("employee.table.no"),  dataIndex: "no", key: "no" },
          { title: this.$t("employee.table.id_card"),  dataIndex: "idCard", key: "idCard" },
          { title: this.$t("employee.table.gender"),  dataIndex: "gender", key: "gender", customRender: ({text}) =>{
              return this.selectList.genderList.find(item=>item.value===text).label
            } 
          },
          { title: this.$t("employee.table.birthday"),  dataIndex: "birthday", key: "birthday", customRender: ({text}) =>{return moment(text).format('YYYY-MM-DD')}},
	        { title: this.$t("employee.table.marital_status"), dataIndex: "maritalStatus", key: "maritalStatus", customRender: ({text}) =>{
              
                return this.selectList.maritalStatusList.find(item=>item.value===text).label
            }
          },
          { title: this.$t("employee.table.duty_plan_type"),  dataIndex: "dutyPlanType", key: "dutyPlanType", customRender: ({text}) =>{
              return this.selectList.dutyPlanTypeList.find(item=>item.value===text).label
            }
          },
          { title: this.$t("employee.table.id_ann_lea_pla"),  dataIndex: "annualLeavePlanPlanName", key: "annualLeavePlanPlanName" },
          { title: this.$t("employee.table.status"),  dataIndex: "status", key: "status", customRender: ({text}) =>{
              return this.selectList.statusList.find(item=>item.value===text).label
            } 
          },
          { title: this.$t("employee.table.enroll_id"),  dataIndex: "enrollId", key: "enrollId" },
          { title: this.$t("employee.table.last_login_time"),  dataIndex: "lastLoginTime", key: "lastLoginTime" },
	  { title: this.$t("employee.table.last_password_update_time"), dataIndex: "lastPasswordUpdateTime", key: "lastPasswordUpdateTime", customRender: ({text}) =>{
      if(text)
      return moment(text).format('YYYY-MM-DD HH:mm:ss')}},
          // { title: this.$t("employee.table.password"),  dataIndex: "password", key: "password" },
          // { title: this.$t("employee.table.salt"),  dataIndex: "salt", key: "salt" },
          // { title: this.$t("employee.table.register_time"),  dataIndex: "registerTime", key: "registerTime" },
          // { title: this.$t("employee.table.login_failure_counter"),  dataIndex: "loginFailureCounter", key: "loginFailureCounter" },
          // { title: this.$t("employee.table.avatar_url"),  dataIndex: "avatarUrl", key: "avatarUrl" },
          // { title: this.$t("employee.table.mobile_number"),  dataIndex: "mobileNumber", key: "mobileNumber" },
          // { title: this.$t("employee.table.phone_number"),  dataIndex: "phoneNumber", key: "phoneNumber" },
          // { title: this.$t("employee.table.email"),  dataIndex: "email", key: "email" },
          // { title: this.$t("employee.table.address"),  dataIndex: "address", key: "address" },
          // { title: this.$t("employee.table.remark"),  dataIndex: "remark", key: "remark" },
          // { title: this.$t("employee.table.emergency_contact"), dataIndex: "emergencyContact", key: "emergencyContact" },
          // { title: this.$t("employee.table.bank_account"), dataIndex: "bankAccount", key: "bankAccount" },
        { key: "action", fixed: "right", slots: { title: "actionTitle", customRender: "action" } },
      ],
      selectList:{
        roleList: [],
        annualLeavePlanList: [],
        departmentList: [],
        genderList:[{value: 0,label: '女'},{value: 1,label: '男'}],
        statusList:[{value: 0,label: '在職'},{value: 1,label: '離職'}],
        dutyPlanTypeList: [{value: 1,label: '週一到週五'},{value: 2,label: '週一到週六早上'},{value: 3,label: '週一到週六'},{value: 4,label: '長短週'}],
        maritalStatusList: [{value: 0,label: '未婚'},{value: 1,label: '已婚'}],
      }
    };
  },
  methods: {
    chang_page(pagination) {
      this.tablePagination = pagination;
      this.get_list();
    },
    get_list() {
      this.loading = true;
      const api = new EmployeeList();
      const getData = {
        page: this.tablePagination.current,
        limit: this.tablePagination.pageSize,
      }
      if (this.searchForm.search != "") getData.search = this.searchForm.search
      getData.status = this.searchForm.status
      if (this.searchForm.idDep != "") getData.idDep = this.searchForm.idDep
      if (this.searchForm.idRol != "") getData.idRol = this.searchForm.idRol
      if (this.searchForm.idAnnLeaPla != "") getData.idAnnLeaPla = this.searchForm.idAnnLeaPla
      if (this.searchForm.dutyPlanType != "") getData.dutyPlanType = this.searchForm.dutyPlanType
      api
        .get(getData)
        .then((response) => {
          this.loading = false;
          if (0 === parseInt(response.data.code)) {
            const dataTmp = response.data.data;
            this.tablePagination.current = parseInt(dataTmp.current);
            this.tablePagination.pageSize = parseInt(dataTmp.pageSize);
            this.tablePagination.total = parseInt(dataTmp.total);
            this.list = dataTmp.data;
            //如果當前處於不是第一頁，但是又沒有數據的情況，則把頁面設置為1，並重新請求
            if(this.list.length == 0 && this.tablePagination.current != 1){
              this.tablePagination.current = 1;
              this.get_list();
            }
          } else {
            this.list = [];
          }
        });
    },
    add() {
      this.$refs.refEmployeeEdit.addShow();
    },
    detail(obj) {
      this.$refs.refEmployeeDetail.detailShow(obj);
    },
    edit(obj) {
      this.$refs.refEmployeeEdit.editShow(obj);
    },
    gccsSetUser(obj){
      this.$refs.refGccsSetUser.putShow(obj);
    },
    resetPassword(obj){
      this.$refs.refResetPassword.show(obj);
    },
    del(idEmp) {
      Modal.confirm({
        title: this.$t("public.name.are_you_sure_delete") + "?",
        content: this.$t("public.name.action_cannot_resumed"),
        icon: createVNode(ExclamationCircleOutlined),
        okText: this.$t("public.name.yes"),
        okType: "danger",
        cancelText: this.$t("public.name.no"),
        onOk: () => {
          const api = new EmployeeDelete();
          api.post({ idEmp: idEmp }).then((response) => {
            if (0 === parseInt(response.data.code)) {
              this.get_list();
              message.success(response.data.msg);
            } else {
              message.error(response.data.msg);
            }
          });
        },
      });
    },
    exportXml() {
      const api = new EmployeeExport();
      const getData = {
      }
      if (this.searchForm.search != "") getData.search = this.searchForm.search
      getData.status = this.searchForm.status
      if (this.searchForm.idDep != "") getData.idDep = this.searchForm.idDep
      if (this.searchForm.idRol != "") getData.idRol = this.searchForm.idRol
      if (this.searchForm.idAnnLeaPla != "") getData.idAnnLeaPla = this.searchForm.idAnnLeaPla
      if (this.searchForm.dutyPlanType != "") getData.dutyPlanType = this.searchForm.dutyPlanType
      api
        .download(getData)
        .then((response) => {
          // console.log(decodeURI(res.headers['filename']));
          let blob = new Blob([response.data], { type: "application/xlsx" });
          let url = window.URL.createObjectURL(blob);
          const link = document.createElement("a"); // 创建a标签
          link.href = url;
          link.download = decodeURI(response.headers['filename']); // 重命名文件
          link.click();
          URL.revokeObjectURL(url);
        });
    },
    quit(idEmp) {
      // Modal.confirm({
      //   title: this.$t("employee.name.are_you_sure_quit") + "?",
      //   content: this.$t("public.name.action_cannot_resumed"),
      //   icon: createVNode(ExclamationCircleOutlined),
      //   okText: this.$t("public.name.yes"),
      //   okType: "danger",
      //   cancelText: this.$t("public.name.no"),
      //   onOk: () => {
      //     const api = new EmployeeQuit();
      //     api.post({ idEmp: idEmp }).then((response) => {
      //       if (0 === parseInt(response.data.code)) {
      //         this.get_list();
      //         message.success(response.data.msg);
      //       } else {
      //         message.error(response.data.msg);
      //       }
      //     });
      //   },
      // });
      this.$refs.refNewEmployeeEntryRecordEdit.quitShow(idEmp);
    },
    revokeQuit(idEmp){
      Modal.confirm({
        title: this.$t("employee.name.are_you_sure_revoke_quit") + "?",
        content: this.$t("public.name.action_cannot_resumed"),
        icon: createVNode(ExclamationCircleOutlined),
        okText: this.$t("public.name.yes"),
        okType: "danger",
        cancelText: this.$t("public.name.no"),
        onOk: () => {
          const api = new EmployeeRevokeQuit();
          api.post({ idEmp: idEmp }).then((response) => {
            if (0 === parseInt(response.data.code)) {
              this.get_list();
              message.success(response.data.msg);
            } else {
              message.error(response.data.msg);
            }
          });
        },
      });
    },
    reinstated(idEmp) {
      this.$refs.refNewEmployeeEntryRecordEdit.reinstatedShow(idEmp);
      // Modal.confirm({
      //   title: this.$t("employee.name.are_you_sure_reinstated") + "?",
      //   content: this.$t("public.name.action_cannot_resumed"),
      //   icon: createVNode(ExclamationCircleOutlined),
      //   okText: this.$t("public.name.yes"),
      //   okType: "danger",
      //   cancelText: this.$t("public.name.no"),
      //   onOk: () => {
      //     const api = new EmployeeReinstated();
      //     api.post({ idEmp: idEmp }).then((response) => {
      //       if (0 === parseInt(response.data.code)) {
      //         this.get_list();
      //         message.success(response.data.msg);
      //       } else {
      //         message.error(response.data.msg);
      //       }
      //     });
      //   },
      // });
    },
    getDepartmentList() {
      const api = new DepartmentListAll();
      api.get().then((response) => {
        if (0 == parseInt(response.data.code)) {
          this.selectList.departmentList = response.data.data;
        } else {
          message.error(response.data.msg);
        }
      });
    },
    getRoleList() {
      const api = new RoleListAll();
      api.get().then((response) => {
        if (0 == parseInt(response.data.code)) {
          this.selectList.roleList = response.data.data;
        } else {
          message.error(response.data.msg);
        }
      });
    },
    getAnnualLeavePlanList() {
      const api = new AnnualLeavePlanListAll();
      api.get().then((response) => {
        if (0 == parseInt(response.data.code)) {
            this.selectList.annualLeavePlanList = response.data.data;
        } else {
            message.error(response.data.msg);
        }
      });
    },
    search_submit() {
      this.get_list()
    },
    search_reset() {
      this.searchForm = {
        status: 0,
        idDep: null,
        idRol:null,
        idAnnLeaPla:null,
        dutyPlanType:null,
      };
      this.get_list()
    }
  },
  mounted() {
    this.get_list();
    this.getDepartmentList();
    this.getRoleList();
    this.getAnnualLeavePlanList();
  },
}
</script>

<style lang="less">
@import url("~@/assets/less/home/employee.less");
</style>